import { Textarea } from '@policygenius/mortar';
import { createUseStyles } from 'react-jss';

import getErrorMessage from 'forms/getErrorMessage';

import { TextAreaFieldProps } from './types';
import styles from '../styles';
import useField from '../useField';

const useStyles = createUseStyles(styles);

const TextAreaField = ({ id, name, config, ...props }: TextAreaFieldProps) => {
  const classes = useStyles();
  const { input, meta } = useField<string, HTMLTextAreaElement>(name, config);

  return (
    <div className={classes.fieldContainer}>
      <Textarea
        {...input}
        {...props}
        id={id ?? name}
        value={input.value ?? undefined}
        errorMessage={getErrorMessage(meta)}
        defaultValue={meta.initial ?? undefined}
      />
    </div>
  );
};

export default TextAreaField;
